import React from "react";
import { Link } from "react-router-dom";
import { CustomerServiceSidebar } from "./Delivery";
import { policyGroups } from "./policyNavigation";
import "../css/content-page.scss";
import "../css/policies.scss";

const summaries = {
  "/shipping": "Processing, tracking, delivery timing and address issues.",
  "/returns": "Eligibility, food-safety exceptions, replacements and refunds.",
  "/orders": "Order acceptance, changes, cancellations and stock issues.",
  "/payments": "Hosted payment processing, billing and refund routing.",
  "/pricing": "Prices, promotional codes, taxes and gift-card principles.",
  "/international": "Customs, duties, import restrictions and currency conversion.",
  "/privacy": "Information handled by the storefront and why it is used.",
  "/privacy-choices": "Access, correction, deletion and other applicable rights.",
  "/cookies": "Local storage, session storage and third-party payment cookies.",
  "/security": "Safer payment practices, fraud screening and issue reporting.",
  "/accessibility": "Accessibility goals, known limitations and assistance.",
  "/product-safety": "Allergens, labels, storage, intended use and health cautions.",
  "/recalls": "Safety notices, customer notification and recall remedies.",
  "/guarantee": "Support for damaged, incorrect or materially misdescribed items.",
  "/terms": "Rules governing use of the storefront and purchases.",
  "/acceptable-use": "Prohibited technical, fraudulent and harmful conduct.",
  "/legal": "Brand ownership, third-party rights and infringement reporting.",
  "/complaints": "Complaint review, escalation and external remedies.",
};

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

function PolicyCenter() {
  return (
    <main className="content-page policy-center">
      <div className="content-page__shell">
        <CustomerServiceSidebar currentPath="/policies" />

        <article className="content-page__article" aria-labelledby="policy-center-title">
          <header className="content-page__header">
            <p className="content-page__eyebrow">Shopping with clarity</p>
            <h1 id="policy-center-title">Policy Center</h1>
            <p className="content-page__lead">
              Find sickzuno’s shopping, privacy, product-safety and legal policies in one place.
            </p>
          </header>

          <p className="content-page__meta">Last updated: October 16, 2026</p>

          <div className="content-page__notice" role="note">
            <strong>Questions?</strong> Email harv@sickzuno.online and include an order
            reference when your question relates to a purchase. Never email card details.
          </div>

          <div className="policy-center__groups">
            {policyGroups.map((group) => (
              <section className="content-page__section" key={group.title}>
                <h2>{group.title}</h2>
                <div className="policy-center__grid">
                  {group.links.map((link) => (
                    <Link
                      className="policy-center__card"
                      key={link.to}
                      to={link.to}
                      onClick={scrollToTop}
                    >
                      <strong>{link.label}</strong>
                      <span>{summaries[link.to]}</span>
                      <small aria-hidden="true">Read policy →</small>
                    </Link>
                  ))}
                </div>
              </section>
            ))}
          </div>
        </article>
      </div>
    </main>
  );
}

export default PolicyCenter;

